// extracted by mini-css-extract-plugin
export default {"eLearning":"E-Learning_eLearning__L6G5M","coursesList":"E-Learning_coursesList__64-Fm","quizDiv":"E-Learning_quizDiv__OW+tf","quizBtn":"E-Learning_quizBtn__Pl6YX"};